import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import UserState from '../states/user/user.state';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class AuthGuard  {

  constructor(private authService: AuthService, private stateStore: Store,
              private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.stateStore.selectSnapshot(UserState);
    const isLoggedIn = this.stateStore.selectSnapshot(UserState.isLoggedIn);

    const parsedUrl = this.router.parseUrl(state.url);
    const walmartCallbackUri = parsedUrl.queryParams['walmartCallbackUri'];
    const primarySegments = parsedUrl.root.children['primary']?.segments || [];
    const isRootPath = primarySegments.length === 0;

    // If user is already logged in and comes with walmartCallbackUri on the root URL,
    // send them directly to Selling Channels with walmartCallbackUri (same as after login flow).
    if (isLoggedIn && walmartCallbackUri && isRootPath) {
      this.router.navigate(['settings/sellingchannels'], {
        queryParams: { walmartCallbackUri }
      });
      return false;
    }

    if (currentUser)
    {
      if ((currentUser.inactiveDays > 7
      || currentUser.exceededDays > 7) && (route as any)._routerState.url != '/'
      && (route as any)._routerState.url != '/settings/billing')
      this.router.navigate(['/']);
    }

    if (currentUser &&
      ((!route.data.permissions || (route.data.permissions && route.data.permissions.some(p => currentUser.permissions.includes(p))))
      && (!route.data.roles || (route.data.roles && route.data.roles.some(p => currentUser.roles.includes(p)))))) {
      return true;
    }
    return this.checkLogin(state.url);
  }

  checkLogin(url: string) {
    if (this.stateStore.selectSnapshot(UserState.isLoggedIn)) {
      this.router.navigate(['']);
      return true;
    }

    const parsedUrl = this.router.parseUrl(url);
    const walmartCallbackUri = parsedUrl.queryParams['walmartCallbackUri'];

    if (walmartCallbackUri) {
      // When walmartCallbackUri is present, redirect to login without returnUrl,
      // passing walmartCallbackUri as-is so the login component can handle it.
      this.router.navigate(['/login'], { queryParams: { walmartCallbackUri } });
    } else {
      // Default behavior: remember the original URL to return to after login.
      this.router.navigate(['/login'], { queryParams: { returnUrl: url } });
    }
    return false;
  }
}
